import React from 'react'
import { Loader } from 'semantic-ui-react';

import CountCardHeader from './../Drive/Cards/CountCardHeader';
import FourBlockDivision from '../Drive/Cards/FourBlockDivision';
import FiveBlockWithHeader from '../Drive/Cards/FiveBlockWithHeader';

import initiative from "../../../../images/svg/noti-initiatives.svg";

class CountBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    componentWillMount() {
        this.setState({ loading: true });
        setTimeout(
            function () {
                this.setState({ loading: false });
            }.bind(this), 2000);
    }

    render() {
        let showLoader = this.state.loading || this.props.loadingInitiative;
        return (
            <div>
                <div className="display-flow-root">
                    <CountCardHeader
                        name="Initiative"
                        type="initiative"
                        image={initiative}
                        totalCount={this.props.intitiativeCountData.total}
                        selectedOrganisation={this.props.selectedOrganisation}
                        history={this.props.history}
                    />
                </div>
                {showLoader ?
                    <div className="setLoader" style={{ padding: "87px 0" }}>
                        <Loader active inline />
                    </div> : ""}
                <div className="count-content">
                    <FourBlockDivision
                        type="initiative"
                        label1Name="In Design"
                        isLoadingData={this.props.isLoadingData}
                        label1Count={showLoader ? 0 : this.props.intitiativeCountData && this.props.intitiativeCountData.inDesign ? this.props.intitiativeCountData.inDesign : 0}
                        label3Name="Active"
                        label3Count={showLoader ? 0 : this.props.intitiativeCountData && this.props.intitiativeCountData.active ? this.props.intitiativeCountData.active : 0}
                        label2Name="Closed"
                        label2Count={showLoader ? 0 : this.props.intitiativeCountData && this.props.intitiativeCountData.closed ? this.props.intitiativeCountData.closed : 0}
                        label4Name="Cancelled"
                        label4Count={showLoader ? 0 : this.props.intitiativeCountData && this.props.intitiativeCountData.cancelled ? this.props.intitiativeCountData.cancelled : 0}
                        selectedOrganisation={this.props.selectedOrganisation}
                        history={this.props.history}
                    />

                    <FiveBlockWithHeader
                        type="initiative"
                        selectedOrganisation={this.props.selectedOrganisation}
                        history={this.props.history}
                        intitiativeCountData={this.props.intitiativeCountData}
                    />
                </div>
            </div>
        )
    }
}

export default CountBlock;
